(function() {
    'use strict';

    dutyFlushService.$inject = ['$http', '$q'];
    angular
        .module('app.dutyFlush')
        .factory('dutyFlushService', dutyFlushService);

    /* @ngInject */
    function dutyFlushService($http, $q) {
        var isPrimed = false;
        var primePromise;

        var service = {
            ready: ready,
            getSectors: getSectors,
            createFormRecord: createFormRecord
        };

        return service;

        function getSectors(pageId) {
            return $http.get('/umbraco/api/calculator/getsectors?pageid=' +pageId)
                .then(function (response) {

                    if (response.data) {
                        return response.data;
                    }
                    return null;
                });
        };

        function createFormRecord(model) {
            if (model.salaryFrequency==="1") {
                model.salaryFrequency= "Per Annum";
            }
            if (model.salaryFrequency==="2") {
                model.salaryFrequency= "Per Month";
            }
            if (model.salaryFrequency==="3") {
                model.salaryFrequency= "Per Week";
            }
            if (model.salaryFrequency==="4") {
                model.salaryFrequency= "Per Hour";
            }

            return $http.post('/umbraco/api/calculator/createdutyflushformrecord', model, {
                headers: { "Content-Type": "application/json; charset=UTF-8" }
            })
                .then(function () {
                });
        };

        function prime() {
            if (primePromise) {
                return primePromise;
            }

            primePromise = $q.when(true).then(success);
            return primePromise;

            function success() {
                isPrimed = true;
                logger.info('Primed data');
            }
        };

        function ready(nextPromises) {
            var readyPromise = primePromise || prime();

            return readyPromise
                .then(function() { return $q.all(nextPromises); })
                .catch(exception.catcher('"ready" function failed'));
        };
    }
})();